import { useState, useRef } from 'react'
import {
  useFloating,
  shift,
  offset,
  useInteractions,
  useClick,
  useDismiss,
  FloatingArrow,
  arrow,
  FloatingPortal,
  FloatingFocusManager,
} from '@floating-ui/react'
import Link from '@components/Link'
import Button from '@components/Button'
import SVGIcon from '@components/SVGIcon'

const AccountMenu = () => {
  const arrowRef = useRef(null)
  const [popoverVisible, setPopoverVisible] = useState(false)

  const { refs, floatingStyles, context } = useFloating({
    open: popoverVisible,
    onOpenChange: setPopoverVisible,
    middleware: [
      offset(8), // offset from reference element
      shift({
        padding: 16, // 16px from window edges
      }),
      arrow({
        element: arrowRef,
      }),
    ],
  })
  const { getReferenceProps, getFloatingProps } = useInteractions([useClick(context), useDismiss(context)])

  const getPopoverContent = () => {
    if (popoverVisible) {
      const content = (
        <ul>
          <li>
            <Link href="/users/edit" title="Your account">
              Account
            </Link>
          </li>
          <li>
            <Link href="/notifications" title="Your notifications">
              Notifications
            </Link>
          </li>
          <li>
            <Link
              href="/users/sign_out"
              title="Sign out of your Timetoast account"
              method="delete"
              rel="nofollow"
              className="qa-account-nav-item"
            >
              Sign out
            </Link>
          </li>
        </ul>
      )
      return (
        <FloatingPortal id="floating-portal-target">
          <FloatingFocusManager context={context} modal={false}>
            <div
              ref={refs.setFloating}
              style={floatingStyles}
              className="popover popover--menu"
              {...getFloatingProps()}
            >
              <FloatingArrow ref={arrowRef} context={context} className="floating-arrow" />
              {content}
            </div>
          </FloatingFocusManager>
        </FloatingPortal>
      )
    }
  }
  return (
    <>
      <Button ref={refs.setReference} {...getReferenceProps()} className="qa-account-menu-trigger">
        <SVGIcon xlinkHref="#streamline-user-circle-single" alt="Account" />
      </Button>
      {getPopoverContent()}
    </>
  )
}

export default AccountMenu
